module.exports = __webpack_public_path__ + "img/tuna-tartar.ef1848d7.jpg";